import ViewModel from "../../commons/base/view_model";

export class FranchiseLandingState { }

export class FranchiseLandingViewModel extends ViewModel<FranchiseLandingState> {
    constructor() {
        super(new FranchiseLandingState());
    }
}